import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValueSection from './components/ValueSection';
import FeatureGrid from './components/FeatureGrid';
import ComparisonSection from './components/ComparisonSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SITE_URL) || 'https://allchinabuy.watch';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'AllChinaBuySpreadsheet',
  url: siteUrl,
  description: 'A next-generation product sourcing spreadsheet system for dropshippers and resellers. Find winning products and compare China suppliers.',
  publisher: {
    '@type': 'Organization',
    name: 'AllChinaBuy',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg',
    },
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar transparent />
      <main>
        <HeroSection />
        <ValueSection />
        <FeatureGrid />
        <ComparisonSection />
        <CategoryGrid />
        <ArticleSection />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
}